import styled from "styled-components";
import BSDashboardCore from "../components/bsDashboardCore";
import PrimaryFilterHelper from "../../../components/primaryFilterHelper";
import { BSContentHeader } from "../components/bsContentHeader";
import BSDashboardStatus from "../components/bsDashboardStatus";
import BSWidgetsGridLayout from "../components/bsWidgetsGridLayout";
import BSContentFooter from "../components/bsContentFooter";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import { media } from "../../../helpers/responsive";

const BusinessSummaryLayout = () => {
  const { maintenance_mode } = useSelector(
    (state: RootState) => state.company.company_details
  );

  return (
    <LayoutWrapper maintenance_mode={maintenance_mode.enabled}>
      <BSDashboardCore>
        <PrimaryFilterHelper>
          <BSContentHeader />
          <BSDashboardStatus>
            <BSWidgetsGridLayout />
          </BSDashboardStatus>
          <BSContentFooter />
        </PrimaryFilterHelper>
      </BSDashboardCore>
    </LayoutWrapper>
  );
};

export default BusinessSummaryLayout;

const LayoutWrapper = styled.div<{ maintenance_mode: boolean }>`
  background-color: ${({ theme }) => theme.body};
  margin-top: ${({ maintenance_mode }) => (maintenance_mode ? "180px" : "125px")};
  transition: all 0.25s linear 0s;

  .date-period {
    font-weight: normal;
    font-size: 15px;
    color: ${({ theme }) => theme.text};
    transition: all 0.25s linear 0s;
  }

  ${media.down.sm} {
    margin-top: ${({ maintenance_mode }) => (maintenance_mode ? "150px" : "100px")};
  }

  ${media.down.xs} {
    margin-top: ${({ maintenance_mode }) => (maintenance_mode ? "130px" : "80px")};
    .date-period {
      font-size: 13px;
    }
  }
`;
